export default {
      id: "ic_scratch_card-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_scratch_card-usage",
      toString: function () {
        return this.url;
      }
    }